import React, { FunctionComponent } from 'react';

import LiveViewContainer from './containers/live-view.container';

const LiveViewModule: FunctionComponent = () => <LiveViewContainer />;

export default LiveViewModule;
